import Chip from "components/common/Chip";
import Image from "components/common/images/Image";
import { CategoryModel, CorpPRModel } from "models";
import React from "react";
import { Utils } from "utils";

type PROPS = {
  data: CorpPRModel;
  category: CategoryModel[];
};

const CorpProfileEditConfirm: React.FC<PROPS> = (props) => {
  const data = props.data;

  return (
    <div>
      <div className="mt-8">以下の内容で会社PR情報を登録します。</div>
      <div className="mt-4 flex flex-col gap-4">
        <div className="pt-4 border-b font-bold">会社PR設定</div>
        <div className="flex justify-between items-center">
          <div className="w-3/12">会社キャッチコピー</div>
          <div className="w-9/12 break-all">{data.catch_phrase}</div>
        </div>
        <div className="flex justify-between items-start">
          <div className="w-3/12">ロゴ画像</div>
          <div className="w-9/12">
            <div className="flex flex-col items-start">
              <Image data={data.logo_image} show_file_name />
            </div>
          </div>
        </div>
        <div className="flex justify-between items-start">
          <div className="w-3/12">メイン画像</div>
          <div className="w-9/12">
            <div className="flex flex-col items-start">
              <Image data={data.corp_image} show_file_name />
            </div>
          </div>
        </div>
        <div className="flex justify-between items-start">
          <div className="w-3/12">会社カテゴリ</div>
          <div className="w-9/12">
            {data.corp_category_list.map((c, index) => {
              const main = Utils.Category.pick(
                c.corp_large_category_id,
                props.category
              );
              const sub = Utils.Category.pick(
                c.corp_medium_category_id ?? "",
                props.category
              );
              return (
                <div key={index} className="flex gap-8">
                  <div>メインカテゴリ: {main?.name}</div>
                  {!!sub && <div>サブカテゴリ: {sub?.name}</div>}
                </div>
              );
            })}
            {/* メインカテゴリ: システム開発 */}
          </div>
        </div>
        <div className="flex justify-between items-start">
          <div className="w-3/12">タグ</div>
          <div className="w-9/12 flex flex-wrap gap-2">
            {data.corp_tag_list.map((tag, index) => {
              return <Chip key={index} text={tag.corp_tag_name} />;
            })}
          </div>
        </div>
        <div className="flex justify-between items-start">
          <div className="w-3/12">会社紹介</div>
          <div className="w-9/12 whitespace-pre-line break-all">{data.introduction}</div>
        </div>
        <div className="flex justify-between items-start">
          <div className="w-3/12">PR画像01</div>
          <div className="w-9/12 flex gap-8">
            <Image data={data.pr_image_1} show_file_name />

            <div className="flex-1 whitespace-pre-line break-all">
              {data.pr_image_text_1}
            </div>
          </div>
        </div>
        <div className="flex justify-between items-start">
          <div className="w-3/12">PR画像02</div>
          <div className="w-9/12 flex gap-8">
            <Image data={data.pr_image_2} show_file_name />
            <div className="flex-1 whitespace-pre-line break-all">
              {data.pr_image_text_2}
            </div>
          </div>
        </div>
        <div className="flex justify-between items-start">
          <div className="w-3/12">PR画像03</div>
          <div className="w-9/12 flex gap-8">
            <Image data={data.pr_image_3} show_file_name />
            <div className="flex-1 whitespace-pre-line break-all">
              {data.pr_image_text_3}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CorpProfileEditConfirm;
